import React, { useContext } from "react";
import classes from "./Banner.module.css";
import homeImageMain from "../../Assets/homeImageMain.png";
import { MyContext } from "../../Context/MyContext";

function Banner() {
  const { appointmentRef, serviceRef } = useContext(MyContext);

  return (
    <section className={classes.hero} id="home">
      <div className={classes.copy}>
        <p className={classes.brand}>DigitaliNation</p>
        <h1 className={classes.headline}>
          Software, marketing, and operations that help you grow.
        </h1>
        <p className={classes.support}>
          We design, build, and run the digital work your business needs to win
          customers.
        </p>
        <div className="ctaRow">
          <button
            className="buttonHome"
            onClick={() => {
              window.location.hash = "#book-appointment";
              appointmentRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }}
          >
            Book a Call
          </button>
          <button
            className="buttonHomeOutline"
            onClick={() => {
              window.location.hash = "#services";
              serviceRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }}
          >
            Our Services
          </button>
        </div>
      </div>
      <div className={classes.visual} aria-hidden="true">
        <img src={homeImageMain} alt="" className={classes.image} />
      </div>
    </section>
  );
}

export default Banner;
